import { ABTest } from '@/libs/abtest'
import { Storage } from './libs/storage'
import { v4 as uuidv4 } from 'uuid'

export class G {
    static readonly PROCESS_ID = uuidv4();
    static readonly APP_VERSION = process.env.VERSION as string
    static readonly REPORT_VERSION = '0.1.0'
    static readonly ABTEST_VERSION = '0.1.0'
    static readonly storage = new Storage()
    static readonly abTest = new ABTest()
}
